
import styles from "./style.less";

type Props = {
    header?: React.ReactNode;
    left?: React.ReactNode;
    children?: React.ReactNode;
    footer?: React.ReactNode;
    className?: string;
    [key: string]: any;
}
export default function Layout(props: Props) {
    const {
        header = null,
        left = null,
        children = null,
        footer = null,
     } = props;

    return (
        <div className={styles.container}>
            {header && <div className={styles.header}>{header}</div>}
            <div className={styles.center}>
                {left && <div className={styles.left}>{left}</div>}
                {children && <div className={styles.content}>{children}</div>}
            </div>
            {footer && <div className={styles.footer}>{footer}</div>}
        </div>
    )
}